export default "__VITE_ASSET__BGIeaHvR__"